import styles from './styles.module.scss'

const Footer = (): JSX.Element => (
  <footer className={styles.footer}>
    <div className={`${styles.content} ${styles.footerContent}`}>
      <img
        className={styles.logo}
        src="/partner-introduction/ecbo-cloak-logo.png"
        alt="ecbo cloak"
      />
      <div>荷物預かりシェアサービス「ecbo cloak」店舗獲得キャンペーン</div>
      <div>© ecbo Inc.</div>
    </div>
  </footer>
)

export default Footer
